import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
const Home = lazy(() => import("../pages/home/page"));
const FounderRedirect = lazy(() => import("../pages/founder/redirect"));
const BlogListPage = lazy(() => import("../pages/blog/page"));
const BlogPostPage = lazy(() => import("../pages/blog/post"));
const BlogPreviewPage = lazy(() => import("../pages/blog/preview"));
const ComingSoonPage = lazy(() => import("../pages/coming-soon/page"));
const IntegrationsPage = lazy(() => import("../pages/integrations/page"));
const PricingPage = lazy(() => import("../pages/pricing/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const NeedPage = lazy(() => import("../pages/need/page"));
const FaqPage = lazy(() => import("../pages/faq/page"));
const PartnerPage = lazy(() => import("../pages/partner/page"));
const KarlilikPage = lazy(() => import("../pages/products/Karlilik"));
const FinansPage = lazy(() => import("../pages/products/Finans"));
const KampanyaPage = lazy(() => import("../pages/products/Kampanya"));
const StokPage = lazy(() => import("../pages/products/Stok"));
const RakipPage = lazy(() => import("../pages/products/Rakip"));
const UyariPage = lazy(() => import("../pages/products/Uyari"));
const AiCrmPage = lazy(() => import("../pages/products/AiCrm"));
const ZekiPage = lazy(() => import("../pages/products/Zeki"));
const TumUrunlerPage = lazy(() => import("../pages/products/TumUrunler"));
const EklentiPage = lazy(() => import("../pages/products/Eklenti"));
const BizKimizPage = lazy(() => import("../pages/about/page"));
const PazaryeriPage = lazy(() => import("../pages/solutions/Pazaryeri"));
const EticaretPage = lazy(() => import("../pages/solutions/Eticaret"));
const CokluMarkaPage = lazy(() => import("../pages/solutions/CokluMarka"));
const OmnichannelPage = lazy(() => import("../pages/solutions/Omnichannel"));
const LegalHubPage = lazy(() => import("../pages/legal/hub"));
const LegalPage = lazy(() => import("../pages/legal/page"));
import { menuPages, needs, routes as siteRoutes } from "../content/site";
import { legalDocs } from "../content/pages/yasal";

/*
 * Sayfalar `lazy`: her sayfa kendi JS parçasına ayrılır (2 Kasım PageSpeed). Ana paket yalnız kabuğu (router,
 * navbar, footer, dock) taşır; ziyaretçi açtığı sayfanın parçasını indirir. Ön-çizim (`entry-server`,
 * `react-dom/static`) lazy'leri bekleyip tam HTML basar; tarayıcı HTML'e bağlanırken parça gelene kadar
 * sunucu çıktısı ekranda kalır. `handle.module` → Vite manifest'teki anahtar; ön-çizim parçayı önden yükletir.
 */
const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />, handle: { module: "src/pages/home/page.tsx" },
  },
  {
    path: `${siteRoutes.kurumsal.kurucular}/:slug`,
    element: <FounderRedirect />, handle: { module: "src/pages/founder/redirect.tsx" },
  },
  {
    path: siteRoutes.entegrasyonlar,
    element: <IntegrationsPage />, handle: { module: "src/pages/integrations/page.tsx" },
  },
  {
    path: siteRoutes.fiyatlar,
    element: <PricingPage />, handle: { module: "src/pages/pricing/page.tsx" },
  },
  {
    path: siteRoutes.iletisim,
    element: <ContactPage />, handle: { module: "src/pages/contact/page.tsx" },
  },
  { path: siteRoutes.sss, element: <FaqPage />, handle: { module: "src/pages/faq/page.tsx" } },
  // Blog: liste, kategori sayfası ve yazı. Yazılar admin panelinden gelir.
  { path: siteRoutes.blog, element: <BlogListPage />, handle: { module: "src/pages/blog/page.tsx" } },
  { path: `${siteRoutes.blog}/kategori/:slug`, element: <BlogListPage />, handle: { module: "src/pages/blog/page.tsx" } },
  // Taslak önizleme (admin'den üretilen süreli belirteç); ":slug"dan önce gelmeli.
  { path: `${siteRoutes.blog}/onizleme/:token`, element: <BlogPreviewPage />, handle: { module: "src/pages/blog/preview.tsx" } },
  { path: `${siteRoutes.blog}/:slug`, element: <BlogPostPage />, handle: { module: "src/pages/blog/post.tsx" } },
  { path: siteRoutes.kurumsal.partnerlik, element: <PartnerPage />, handle: { module: "src/pages/partner/page.tsx" } },
  { path: siteRoutes.kurumsal.bizKimiz, element: <BizKimizPage />, handle: { module: "src/pages/about/page.tsx" } },
  // Ürün sayfaları; her biri kendi tasarımıyla. Bölüm sayfası (/ozellikler) tüm ürünlerin listesidir.
  { path: siteRoutes.ozellikler.root, element: <TumUrunlerPage />, handle: { module: "src/pages/products/TumUrunler.tsx" } },
  { path: siteRoutes.araclar.chrome, element: <EklentiPage />, handle: { module: "src/pages/products/Eklenti.tsx" } },
  { path: siteRoutes.ozellikler.karlilik, element: <KarlilikPage />, handle: { module: "src/pages/products/Karlilik.tsx" } },
  { path: siteRoutes.ozellikler.hakedis, element: <FinansPage />, handle: { module: "src/pages/products/Finans.tsx" } },
  { path: siteRoutes.ozellikler.kampanya, element: <KampanyaPage />, handle: { module: "src/pages/products/Kampanya.tsx" } },
  { path: siteRoutes.ozellikler.stok, element: <StokPage />, handle: { module: "src/pages/products/Stok.tsx" } },
  { path: siteRoutes.ozellikler.rekabet, element: <RakipPage />, handle: { module: "src/pages/products/Rakip.tsx" } },
  { path: siteRoutes.ozellikler.uyari, element: <UyariPage />, handle: { module: "src/pages/products/Uyari.tsx" } },
  { path: siteRoutes.ozellikler.crm, element: <AiCrmPage />, handle: { module: "src/pages/products/AiCrm.tsx" } },
  { path: siteRoutes.ozellikler.zeki, element: <ZekiPage />, handle: { module: "src/pages/products/Zeki.tsx" } },
  // Satış kanalına göre çözüm sayfaları; her biri kendi tasarımıyla.
  { path: siteRoutes.cozumler.pazaryeri, element: <PazaryeriPage />, handle: { module: "src/pages/solutions/Pazaryeri.tsx" } },
  { path: siteRoutes.cozumler.eticaret, element: <EticaretPage />, handle: { module: "src/pages/solutions/Eticaret.tsx" } },
  { path: siteRoutes.cozumler.cokluMarka, element: <CokluMarkaPage />, handle: { module: "src/pages/solutions/CokluMarka.tsx" } },
  { path: siteRoutes.cozumler.omnichannel, element: <OmnichannelPage />, handle: { module: "src/pages/solutions/Omnichannel.tsx" } },
  // İhtiyaca göre çözüm sayfaları tek şablonu paylaşır; içerik adresten seçilir.
  ...needs.map((need) => ({
    path: need.href,
    element: <NeedPage />, handle: { module: "src/pages/need/page.tsx" },
  })),
  // Yasal metinler: dizin sayfası ve her belge için tek şablon.
  { path: siteRoutes.yasal.root, element: <LegalHubPage />, handle: { module: "src/pages/legal/hub.tsx" } },
  ...legalDocs.map((doc) => ({
    path: doc.href,
    element: <LegalPage />, handle: { module: "src/pages/legal/page.tsx" },
  })),
  // Menüdeki her adres için "Çok Yakında" sayfası. Bir sayfa hazır olduğunda
  // kendi kaydı bu listenin üstüne eklenip buradaki eşleşmeyi geçersiz kılar.
  ...menuPages.map((page) => ({
    path: page.href,
    element: <ComingSoonPage />, handle: { module: "src/pages/coming-soon/page.tsx" },
  })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
